import React from 'react'
import clsx from 'clsx'
import { competitionGenerateUrl } from '../../../shared/competitionUrls'
import styles from './styles.module.scss'

export const AllCompetitionsButton = () => (
    <a href={competitionGenerateUrl({})} className={styles.component}>
        Retrouvez toutes les compétitions
        <i className={clsx('fi fi-rs-angle-small-right', styles.arrow)} />
        <div className={styles.bottomLine} />
    </a>
)
